import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

const API_URI = environment.basePath + '/hypermed';

@Injectable({
  providedIn: 'root'
})
export class MigrationService {

  constructor(
    private _httpClient: HttpClient,
  ) { }

  public async getBucketCryptedInfos(cabinetId: string): Promise<CryptedBucketInfos> {
    try {
      const res = await this._httpClient.get<CryptedBucketInfos>(`${API_URI}/cabinet/${cabinetId}/cryptedBucket`).toPromise();
      return res;
    } catch (err) {
      throw err;
    }
  }
}

export interface CryptedBucketInfos {
  authBucket: string;
  ivBucket: string;
}
